import type { QuoterMarketConfig } from '../contract/market';

export const INT: QuoterMarketConfig = {
  country: 'INT',
  label: 'Internacional',
  riders: ['terminal-illness', 'funeral', 'rop', 'add', 'critical-cancer', 'income-replacement'],
  languages: [
    { code: 'es', label: 'Español' },
    { code: 'en', label: 'English' },
    { code: 'pt', label: 'Português' },
  ],
  // quotation_validate.go: rejects ages over 75 and any term that takes the insured past 85.
  age: { min: 18, max: 75, maxAtExpiry: 85 },
  terms: ['10', '15', '20', '30'],
  termRule: 'pricedByEngine',
  // INT cotiza solo anual: sin selector de frecuencia.
  frequencies: ['A'],
  // quotation_validate.go: easy_term llega hasta 5M, master_term arranca en 5,1M, y los montos
  // que no son múltiplo del step se rechazan con un 400 que descarta la edición.
  mainCoverage: { min: 100000, max: 5000000, step: 10000, easyTermMax: 5000000 },
  amountRounding: 'down',
  productRule: 'coverageBands',
  addRider: {
    min: 50000,
    step: 25000,
    defaultAmount: 50000,
    rangeRule: 'cappedByMainCoverage',
  },
  // Closed catalogs the API validates against (quotation_validate.go).
  accidentRiders: null,
  totalCoverageLimit: null,
  thousandsSeparator: ',',
  criticalIllnessCancer: {
    source: 'declared',
    amounts: [20000, 50000, 100000],
    types: ['ci', 'cp'],
    plans: ['individual', 'family'],
    defaultAmount: 50000,
    defaultPlan: 'individual',
  },
  incomeReplacement: {
    // The API prices the rider at exactly 300000, so the inclusive bound is the correct one.
    minCoverage: 300000,
    minAnnualIncome: 17000,
    // `shared.IsIncomeReplacementApplicable` bounds the age on a narrower range than the policy's.
    minAge: 18,
    maxAge: 64,
    // Fixed per tier: the API catalog only supplies the price, so the labels never render empty
    // when it declines to price the rider.
    tiers: [
      { tier: 1, permanent: 100000, temporary: 1000 },
      { tier: 2, permanent: 200000, temporary: 2000 },
      { tier: 3, permanent: 300000, temporary: 3000 },
    ],
    defaultCode: 'ttd_ptd_1',
    defaultPtdAmount: 100000,
  },
  funeralExpenses: { amount: 2500 },
  returnOfPremium: { termsWithout: ['10'] },
  pricingVersion: null,
  freeInstallmentsPromotion: false,
  brandingSource: null,
  insuredAmountSummary: false,
  editing: { stepperDebounceMs: 700 },
};
